import React, { useState } from "react";
import logo from "./logo.svg";
import "./reset.css";
import "./app.css";

import { SlideShow } from "./components/slideshow";
import { Information } from "./components/information";
import { Navigation } from "./components/navigation";

const slides = [
  {
    url: "/slides/4Johnny_Depp_A_Bunch_Of_Stuff_052 (1)web.jpg",
    scale: 1.0,
    minDelay: 2000,
  },
  { url: "/slides/19_Beuys poster_inSitu2.jpg", scale: 1.0, minDelay: 1500 },
  { url: "/slides/14Johnny_Depp_A_Bunch_Of_Stuff_013web.jpg" },
  { url: "/slides/1Johnny_Depp_A_Bunch_Of_Stuff_051 (1)web.jpg" },

  { url: "/slides/5 FEI_WORKSAMPLES_additionals_JD.png" },
  { url: "/slides/Adobe Express - RIA_Recall_titlesequence1080x1080 (1).gif" },
  { url: "/slides/Aperture_Identity_3.jpg" },
  { url: "/slides/Aralkum_MockUps_cover_w.jpg" },
  { url: "/slides/BBR_packshots with poster.jpg" },
  { url: "/slides/Ballon_insitumockup2e.jpg" },
  { url: "/slides/CS021insideimage.jpg" },
  { url: "/slides/ChinaTravelTubeAds_i_c3s.jpg" },
  { url: "/slides/Cocky_logo.png" },
  { url: "/slides/ComingUpforAir_screen.jpg" },
  { url: "/slides/DH OC_bass_artmusicadsmall.jpg", minScale: 1.0 },
  { url: "/slides/GalyaIceDiveOst_FrontBack1.jpg" },
  { url: "/slides/HChoir disc MockUp_st2.jpg" },
  { url: "/slides/HM_treeL2notext.jpg" },
  { url: "/slides/KOD_packshotsFEI_WORKSAMPLES_MUSICINDUSTRY_20_kod.png" },
  { url: "/slides/KOD_packshots_mdres.jpg" },
  { url: "/slides/Next Sohee_UKposter_40x30inTestFcopy.jpg" },
  { url: "/slides/Packshot_S3situ1.jpg" },
  { url: "/slides/Packshot_Xstudio_AVA1both.jpg" },
  { url: "/slides/Packshot_Xstudio_Prats3.jpg" },
  { url: "/slides/Packshot_Xstudio_tmplt_gab0.jpg" },
  { url: "/slides/RememberEveryNight_UKposter_promo1.gif" },
  { url: "/slides/Rgirl100_onscreen.jpg" },
  { url: "/slides/Rgirl25_showad2 copy.jpg" },
  { url: "/slides/Rocketgirl20_poster_30x40in_lowf.jpg" },
  { url: "/slides/SHHE_cover_screen copy.jpg" },
  { url: "/slides/Screenshot 2026-07-15 at 11.51.49.png" },
  { url: "/slides/Screenshot 2026-07-16 at 19.31.36.png" },
  { url: "/slides/Screenshot 2026-07-16 at 19.32.47.png" },
  { url: "/slides/ScreentoMind_poster_square_situ0b.jpg" },
  { url: "/slides/ScreentoMind_poster_square_situ481591537940_.pic_hd.jpg" },
  { url: "/slides/Snow Leopard_UKposter_A_screen.jpg" },
  { url: "/slides/TCS_pack_cover.jpg" },
  { url: "/slides/Too Late to Die Young_Poster1016x762 copy.jpg" },
  { url: "/slides/Ultrasound_mockups_frontonAll_red.jpg" },
  { url: "/slides/Y4mobile9.jpg" },
  { url: "/slides/arkane_arkive_packshots_master.jpg" },
  { url: "/slides/cardgraphics1.jpg" },
  { url: "/slides/dagger tattoo_final3bw reverse.jpg" },
  { url: "/slides/photo_MG_8757test.jpg" },
  { url: "/slides/s3_labelmix.png" },
  { url: "/slides/sjn WA5G0057.png" },
  { url: "/slides/varity WA5G0152.png" },
  { url: "/slides/DK011175_36ZF1ZtpEdit.jpg" },
  { url: "/slides/Azusa_web26.jpg" },
  { url: "/slides/CC_PH_web 26.jpg" },
  { url: "/slides/margate 3.jpg" },
];

function App() {
  const [infoOpen, setInfoOpen] = useState(false);
  return (
    <div className="App">
      <SlideShow slides={slides} />
      {!infoOpen && <Navigation onOpen={() => setInfoOpen(true)} />}
      {infoOpen && <Information onClose={() => setInfoOpen(false)} />}
    </div>
  );
}

export default App;
